import { useTranslation } from 'react-i18next';
import { CombinedBillingDashboard } from '../../../components/Billing/CombinedBillingDashboard';
import { PageHeader } from '../../../components/Common/PageHeader';

export function AccountBillingUsagePage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader
        title={t('glob_navigation.usageAndCredits')}
        subtitle="Your credit balance and recent account activity."
      />
      <CombinedBillingDashboard />
    </>
  );
}
